export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '9e477b69-a82b-4afa-9925-24b9777220ef';
export const MODAL_CLOSE_SECONDS = 2.5;
